import React from "react";
import { Text, Flex, Box } from "@chakra-ui/react";
import { BsTwitter } from "react-icons/bs";
import { FaTelegramPlane } from "react-icons/fa";

// Constants
import {
  FIREBASE_EVENT_PROPERTIES,
  TELEGRAM_URL,
  TWITTER_URL,
} from "constants/constants";
import useHashConnect from "hooks/useHashConnect";
import { firebaseEvents } from "utils/firebase";

const Socials = () => {
  const { selectedAccount, walletData } = useHashConnect();
  const sendLog = (name: string) => {
    let firebaseRequest: any = {
      [FIREBASE_EVENT_PROPERTIES.EVENT_NAME]: "Join_our_community",
      [FIREBASE_EVENT_PROPERTIES.JOC_TYPE]: name,
      [FIREBASE_EVENT_PROPERTIES.WALLET_NAME]:
        walletData.pairedWalletData?.name,
      [FIREBASE_EVENT_PROPERTIES.WALLET_ADDRESS]: selectedAccount,
    };
    firebaseEvents(firebaseRequest);
  };
  return (
    <Flex
      flexDir="column"
      gap="1rem"
      color="brand.social.text"
      bg="brand.backgroundLight"
      justifyContent="space-between"
      alignItems="center"
      p={{ base: "0", xl: "1rem" }}
      borderRadius="1rem 1rem 0 0"
      pb="0"
    >
      <Text>Our Community</Text>
      <Flex align="center" fontSize="1rem" gap="1rem">
        <a
          href={TWITTER_URL}
          target="_blank"
          rel="noreferrer"
          onClick={() => sendLog("Twitter")}
        >
          <Box
            color="brand.social.icon"
            transition="all 0.15s ease-in-out"
            _hover={{
              color: "brand.primary",
              transform: "scale(1.5)",
            }}
            _dark={{
              _hover: {
                color: "white",
              },
            }}
          >
            <BsTwitter />
          </Box>
        </a>
        <a
          href={TELEGRAM_URL}
          target="_blank"
          rel="noreferrer"
          onClick={() => sendLog("Telegram")}
        >
          <Box
            color="brand.social.icon"
            transition="all 0.15s ease-in-out"
            _hover={{
              color: "brand.primary",
              transform: "scale(1.5)",
            }}
            _dark={{
              _hover: {
                color: "white",
              },
            }}
          >
            <FaTelegramPlane />
          </Box>
        </a>
      </Flex>
    </Flex>
  );
};

export default Socials;
